import { defaultThemeVariables } from './defaultThemeVariables';
export const getThemeVariables = (customThemeVariables = {}) => Object.keys(customThemeVariables).length
    ? Object.entries(customThemeVariables).reduce((result, [key, value]) => (Object.assign(Object.assign({}, result), { [key]: value !== null && value !== void 0 ? value : defaultThemeVariables[key] })), defaultThemeVariables)
    : defaultThemeVariables;
//# sourceMappingURL=getThemeVariables.js.map